<template>
  <div class="chart-comments-ui-container">
    <textarea
      id="chart-comments-textarea"
      class="sc3-textarea sc3-textarea-resizeable"
      placeholder="Type here to add comments about your chart"
      v-model="comments"
      :readonly="isSavingChartComments || isSymbolBeingViewedNotFound || isSymbolBeingViewedAnEODSymbolOnAnIntradayChart"
    ></textarea>
    <button
      type="button"
      class="sc3-button sc3-button-green"
      @click="saveChartComments(comments)"
      :disabled="isSavingChartComments || isSymbolBeingViewedNotFound || isSymbolBeingViewedAnEODSymbolOnAnIntradayChart"
    >
      <i v-show="!isSavingChartComments" class="fas fa-fw fa-check-circle"></i>
      <i v-show="isSavingChartComments" class="fad fa-fw fa-spinner-third fa-spin"></i>
      &nbsp;Save Comments
    </button>
    <button
      type="button"
      class="sc3-button sc3-button-light-grey"
      @click="handleCancel()"
    >Cancel</button>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from 'vue';
  import { useChartComments } from '@/composables/useChartComments';
  import { useSymbolInformation } from '@/composables/useSymbolInformation';

  const { chartBeingViewedComments, isSavingChartComments, saveChartComments } = useChartComments();
  const { isSymbolBeingViewedNotFound, isSymbolBeingViewedAnEODSymbolOnAnIntradayChart } = useSymbolInformation();
  const comments = ref(chartBeingViewedComments.value);

  function handleCancel() {
    comments.value = chartBeingViewedComments.value;
  }

  watch(chartBeingViewedComments, (newValue) => {
    comments.value = newValue;
  });
</script>

<style scoped>
  .chart-comments-ui-container {
    margin: 6px;
  }

  #chart-comments-textarea {
    margin-bottom: 0px;
    min-height: 200px;
    max-height: 400px;
  }

  .sc3-button {
    margin-bottom: 0px;
  }

  .sc3-button:first-of-type {
    margin-left: 0px;
    margin-right: 0px;
  }
</style>
